import { Box, Button, Flex, HStack, InputGroup, Input, InputLeftElement, MenuItem, MenuList, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { RiAddFill, RiSearch2Fill } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import LogoutMenu from '../../../components/dashboard/Layout/logout-menu'
import { openCreateChapterModel, openCreateEvent, openCreateStreaming } from '../../../modules/admin-modules/models/Actions'

const SearchBar = ({ setAdd, setSelectedData }) => {
    const dispatch = useDispatch()
    const count = useSelector((state) => state.chapters.count)

    return (
        <VStack w='100%' my='30px'>

            <Flex alignItems='center' w='100%' justifyContent='space-between'>
                <Text fontSize='24px'
                    fontWeight='600' color='main_1'>
                    الفصول
                </Text>

                <Flex alignItems='center'  >
                    <Button borderRadius='16px' leftIcon={<RiAddFill />} mx='8px' color='white' bg='main_1' _focus={{ outline: 'none' }} onClick={() => {
                        setAdd(true)
                        dispatch(openCreateChapterModel())
                    }
                    }>
                        إضافة فصل
                    </Button>

                    <LogoutMenu />
                </Flex>


            </Flex>
            <Text w='100%' fontSize='20px' textAlign='right'>   عدد الفصول: {count}</Text>


            <HStack w='100%' justifyContent='space-between' bg='#f5f5f5' mt='40px !important' p='10px' mb='-30px !important'>
                <HStack spacing='5px'>

                    <InputGroup w='400px'>
                        <InputLeftElement
                            pointerEvents='none'
                            children={<RiSearch2Fill color='main_1' fontSize='20px' />}
                        />
                        <Input type='text' placeholder='عنوان الفصل' borderRadius='16px' bg='white' />
                    </InputGroup>
                </HStack>



            </HStack>

        </VStack>



    )
}

export default SearchBar